export { createQueryFunction } from './searchPredictions';
